<template>
    <span class="kioskMyPlace kioskGuest">

		<div id="printView">
			<div style="width: 302px;margin:0px">
				<img v-bind:src="$store.state.printAssets.logo" width="300" height="77"/>
				<br/>

				<span class="title">{{ $store.state.kioskEvent.name }}</span>
				<br/>

				<img v-bind:src="$store.state.printAssets.divider" v-if="!$store.state.kioskEvent.isConference"/>
				<div v-if="$store.state.kioskEvent.isConference" style="width:100%;height:3px;background-color: #ccc;margin:10px 10px 10px 10px"></div>
				<br/>
				{{ guest.fullName + (guest.status.coming > 1 ? ` ${guest.status.coming}` : '') }}

				<br v-if="$store.state.kioskEvent.isConference && guest.company && guest.company !== ''"/>
                <span v-if="$store.state.kioskEvent.isConference && guest.company && guest.company !== ''">{{ guest.company }}</span>

                <br v-if="$store.state.kioskEvent.isConference && guest.role && guest.role !== ''"/>
                <span v-if="$store.state.kioskEvent.isConference && guest.role && guest.role !== ''">{{ guest.role }}</span>

				<br/>
				{{(getTables().length > 0  ? $t('table') + ' ' + getTables().join(',') : ($store.state.kioskEvent.isConference ? '' : $t('notSeatedGuest_2'))) }}
				<br/>

				<img v-if="guest.hasOwnProperty('printNote') && guest.printNote !== '' && guest.printNote && !$store.state.kioskEvent.isConference" v-bind:src="$store.state.printAssets.divider"/>
                <div v-if="guest.hasOwnProperty('printNote') && guest.printNote !== '' && guest.printNote && $store.state.kioskEvent.isConference" style="width:100%;height:3px;background-color: #ccc;margin:10px 10px 10px 10px"></div>

				<br v-if="guest.hasOwnProperty('printNote') && guest.printNote !== '' && guest.printNote"/>
				{{ guest.printNote ? guest.printNote : '' }}
				<br v-if="guest.hasOwnProperty('printNote') && guest.printNote !== '' && guest.printNote"/>

				<div class="footer">
					{{ $store.state.app.domain === 'app.seatup.co.il' || $store.state.app.domain === 'dev' ? '052-644-3837' : contactPhone }}<br/>
                    {{ $store.state.app.domain === "app.seatup.co.il" ? "www.seatup.co.il" : $store.state.app.domain }}
				</div>
			</div>
		</div>

        <div class="topFlo" v-if="!$store.state.kioskEvent.isConference"></div>
        <h1>{{ $store.state.kioskEvent.name }}</h1>
        <button @click="this.$parent.goBack" class="backBtn">
			<span>{{ $t('back') }}</span>
			<svg class="i_longArr"><use xlink:href="#i_longArr"></use></svg>
        </button>
		<div class="mainImgWrap">
			<h2>{{ $t('thanksForComing') }}</h2>
			<h3>{{ guest.fullName }}</h3>
			<div class="peopleAmount">

				<i class="guestArrived la" v-bind:class="(guest.arrived ? 'la-check-circle' : 'la-circle')" @click="setArrived()"></i>

				<svg class="i_user"><use xlink:href="#i_user"></use></svg>
				<span @click="amountChangerControl()">
					{{ guest.status.coming > 0 ? guest.status.coming : guest.quantity }}x
					<div class="quantityController" v-if="guest.originalQuantity > 1 && showAmountChanger">
                        <ul>
                            <li v-for="n in guest.originalQuantity" @click="changeComing(n)">{{ n }}</li>
                        </ul>
                    </div>
				</span>
			</div>
			<h4>{{ table.tableNum ? $t('tableNumber') : '&nbsp;' }}</h4>
			<div class="tableNumber" style="text-shadow: 0px 1px 22px rgba(150, 150, 150, 0.64);">{{(getTables().length > 0  ? getTables().join(',') : table.tableNum) }}</div>
			<div class="decorate_1" v-if="!$store.state.kioskEvent.isConference"></div>
			<button class="printBtn" @click="sendToPrinter()">
				<svg class="i_printer"><use xlink:href="#i_printer"></use></svg>
				<span>{{ $t('print') }}</span>
			</button>
			<router-link v-if="this.guest.tableID" v-bind:to="'/guests/myPlace/' + this.guest.tableID + '/table/'" class="bottomLink">{{ $t('whoIsWithMe') }}</router-link>
		</div>
		<KioskFooter active="guest"></KioskFooter>
        <div class="bottomMenuWrap">
            <KioskLanguageSelector></KioskLanguageSelector>
            <AdminMenu v-on:openMenu="adminMenuOpened = true"></AdminMenu>
            <button class="adminEnt" @click.prevent="showArrivalStatus()">
                <Clock  />
            </button>
            <KioskArrivalStatus v-if="arrivalStatusOpened" v-on:close="arrivalStatusOpened = false"></KioskArrivalStatus>
        </div>
        <EventSelectModal @setEvent="setEvent" v-if="!$store.state.kioskEvent.id"></EventSelectModal>
		<AdminMenu :modal="true" v-if="adminMenuOpened" v-on:closeMenu="closeMenu"></AdminMenu>
        <Keyboard></Keyboard>
    </span>
</template>

<script>
    import KioskLanguageSelector from '../Kiosk/KioskLanguageSelector'
    import KioskFooter from '../Kiosk/KioskFooter'
    import EventSelectModal from '../Modals/EventSelectModal'
    import AdminMenu from '../Modals/AdminMenu'
    import Clock from 'vue-digital-clock'
    import Keyboard from './Keyboard'
    import KioskArrivalStatus from './KioskArrivalStatus'
    import printJS from 'print-js';

    export default {
        name: "KioskGuest",
        components:{
            KioskLanguageSelector,
            EventSelectModal,
            AdminMenu,
            Clock,
            KioskFooter,
            Keyboard,
            KioskArrivalStatus
        },
        data(){
            return {
                adminMenuOpened:false,
                arrivalStatusOpened:false,
                showAmountChanger:false,
				guest:{status:{}},
                starting:0,
                table:{}
            }
        },
        mounted(){
            let _this = this;
            if(!this.$store.state.kioskEvent.id) {
                this.$router.push('/')
            }else{
                this.processKiosk();
            }

            if(typeof this.guest !=='undefined' && this.guest.id && !this.guest.arrived){
                this.starting = this.guest.status.coming;
                this.guest.arrived = true;
                this.saveArrival();
            }

        },
		beforeMount(){
            if(typeof this.$router.currentRoute.params.id !=='undefined' && this.$router.currentRoute.params.id != ''){
                let g = this.$store.state.kioskEvent.guests.filter(guest=>{
                    if(guest.id == this.$router.currentRoute.params.id) return true;
                    return false;
				}).pop()
				if(typeof g !=='undefined' && g.id){
                    this.guest = g;
                }
                if(typeof this.guest ==='undefined' ||!this.guest.id) this.$router.push('/guests/myPlace')
            }else{
                this.$router.push('/guests/myPlace')
			}

            for(let table of this.$store.state.kioskEvent.presetData){
                if(table.dbID == this.guest.tableID){
                    this.table = table;
                }
            }

        },
        methods:{
            changeComing(_ = 0){
                this.guest.quantity = _;
                this.guest.status.coming = _;
                this.saveArrival();
			},
            saveArrival(){
                // not -
                if(this.guest.arrived && this.guest.status.coming === 0){
                    this.guest.status = {
                        coming:this.guest.quantity,
                        notComing:0,
                        maybeComing:0,
						reserve:0,
                        notResponded:0,
					};
				}
                let modification = {id:this.guest.id,arrived:this.guest.arrived,status:this.guest.status,quantity:this.guest.quantity,event:this.guest.event};
                this.$store.dispatch('updateGuest',modification)
										.then(response =>{
											//success
											for(let guest in this.$store.state.kioskEvent.guests){
											    if(this.$store.state.kioskEvent.guests[guest].id == response.id){
											        this.$store.state.kioskEvent.guests[guest]= response;
                                                }
											}
                                        })
                                        .catch(err => {
                                            //err

											//add save to queue and continue as normal
											this.$store.state.axiosQueue.push({method:'updateGuest',data:modification})
                                            for(let guest in this.$store.state.kioskEvent.guests){
                                                if(this.$store.state.kioskEvent.guests[guest].id == modification.id){
                                                    this.$store.state.kioskEvent.guests[guest]= Object.assign(this.guest,modification);
                                                }
                                            }
                                        })
			},
            closeMenu(){
                this.adminMenuOpened = false;
            },
            setEvent(eventID){
                this.$store.state.kioskEvent = this.$store.state.closestEvents.filter(event => {
                    if(event.id == eventID) return true;
                    return false;
                }).pop();
                if(this.$store.state.kioskEvent.id){
                    this.processKiosk();
                }else{
                    this.$store.dispatch('logoff')
                }
            },

            processKiosk(){
                //nothing to do right now
            },

            sendToPrinter(){
                $("#printView").show().css({display:'inline'});
                printJS({honorMarginPadding :false,printable: 'printView',type:'html',header:null,showModal: true,targetStyles:['*']})
                $("#printView").hide();
            },

            amountChangerControl(){
                if(this.showAmountChanger){
                    this.showAmountChanger = false;
                }else{
                    this.showAmountChanger = true;
                }
            },
			setArrived(){
                this.guest.arrived = (this.guest.arrived ? false : true);
                this.saveArrival();
			},
            showArrivalStatus(){
                this.arrivalStatusOpened = !this.arrivalStatusOpened;
                const _this = this;
                setTimeout(function(){ _this.arrivalStatusOpened = false },5000);
            },
			getTables(){
                if(!this.guest.tableNumber) return [];
                let tables = [this.guest.tableNumber];
                if(this.$store.state.kioskEvent.groupSeating && this.table.hasOwnProperty('name') && this.table.name && this.table.name !== ''){
                    tables = this.$store.state.kioskEvent.presetData.filter(tbl=>tbl.hasOwnProperty('name') && tbl.name === this.table.name).map(tbl=>tbl.tableNum)
                }

                if(tables.length){
                    const _tables = Object.assign([],tables);

                    try {
                    tables.sort((a,b)=>a-b)

                    //check if table numbers
                        tables = this.groupArray(tables.map(table => parseInt(table)));
                        for(const i in tables){
                            if(tables.hasOwnProperty(i) && tables[i].length > 1){
                                tables[i] = `${Math.min(...tables[i])}-${Math.max(...tables[i])}`;
							}
						}
                    } catch (e){
                        // i dont care
						tables = _tables;
					}

                }
                return tables;
			},

            groupArray(a) {
                const ret = [];
                if (!a.length) return ret;
                let ixf = 0;
                for (let ixc = 1; ixc < a.length; ixc += 1) {
                    if (a[ixc] !== a[ixc-1] + 1) {
                        ret.push(a.slice(ixf, ixc));
                        ixf = ixc;
                    }
                }
                ret.push(a.slice(ixf, a.length));
                return ret;
            }
        }
    }
</script>
<style>
	@page {
		margin: 0;
	}
	#printView{
		font-family: Arial;
		font-size:25px;
		width:100%;
		text-align: center;
		display: none;
		color:black !important;
	}
	#printView .title{
		font-weight: bold;
	}
	#printView .footer{
		font-size: 17px;
		margin-top: 10px;
		border-top: 1px solid #a8a8a8;
	}
	.guestArrived{
		font-size: 25pt;
		position: absolute;
		margin-right: -46px;
		color: #8b8b8b;
	}
</style>
